import React from "react";

export default function IndexSectionPricing4() {
  return (
    <React.Fragment>
      <>
        <section
          className="relative pb-24 overflow-hidden bg-gray-50"
          id="pricing"
        >
          <div className="pt-32 pb-52 bg-orange-50">
            <div className="container px-4 mx-auto">
              <div className="max-w-2xl lg:max-w-5xl mx-auto mb-24 text-center">
                <span className="inline-block py-1 px-3 mb-4 text-xs font-semibold bg-orange-900 text-orange-100 rounded-full uppercase">
                  Pricing
                </span>
                <h1 className="font-heading text-4xl sm:text-6xl lg:text-7xl font-bold text-gray-900 mb-6">
                  <span>明確な料金体系</span>
                </h1>
                <p className="text-lg text-gray-500">
                  決済プラットフォーム「Stripe」を利用し、クレジットカード・銀行振込に対応しています。
                </p>
              </div>
            </div>
          </div>
          <div className="container px-4 mx-auto">
            <div className="max-w-md lg:max-w-4xl mx-auto">
              <div className="-mt-52 mb-16 lg:mb-8 py-9 px-8 sm:px-14 bg-white rounded-3xl shadow-xl">
                <div className="flex flex-wrap -mx-4 items-center">
                  <div className="w-full lg:w-2/5 mb-8 lg:mb-0 px-4 pb-12 lg:py-4 border-b lg:border-0 lg:border-r border-gray-100">
                    <div className="text-center">
                      <span className="block text-2xl font-semibold mb-4">
                        定額制
                      </span>
                      <span className="block text-5xl font-bold text-gray-900 mb-5">
                        4,200円
                      </span>
                      <a
                        className="relative group inline-block py-4 px-10 text-center text-orange-50 bg-orange-900 font-semibold rounded-full overflow-hidden transition duration-200"
                        href="#"
                      >
                        <div className="absolute top-0 right-full w-full h-full bg-gray-900 transform group-hover:translate-x-full group-hover:scale-102 transition duration-500" />
                        <span className="relative">お見積もり</span>
                      </a>
                    </div>
                  </div>
                  <div className="w-full lg:w-3/5 px-4 py-2">
                    <div className="max-w-sm ml-auto">
                      <p className="text-gray-500 mb-8">
                        メール連携以外をご希望の場合は、初期費用（開発費用）として
                        15万円が別途かかります。
                      </p>
                      <ul>
                        <li className="flex mb-6 items-center">
                          <img
                            src="saturn-assets/images/pricing/green-check.svg"
                            alt
                          />
                          <span className="ml-2 text-sm text-gray-900">
                            1拠点
                          </span>
                        </li>
                        <li className="flex mb-6 items-center">
                          <img
                            src="saturn-assets/images/pricing/green-check.svg"
                            alt
                          />
                          <span className="ml-2 text-sm text-gray-900">
                            無制限のQRコード読み取り回数
                          </span>
                        </li>
                        <li className="flex items-center">
                          <img
                            src="saturn-assets/images/pricing/green-check.svg"
                            alt
                          />
                          <span className="ml-2 text-sm text-gray-900">
                            メールによる第三者への通知
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:flex items-center justify-center">
                <div className="flex mb-12 lg:mb-0 sm:mr-24 items-center max-w-xs">
                  <div className="flex flex-shrink-0 w-12 h-12 items-center justify-center rounded-full bg-gray-100">
                    <img src="saturn-assets/images/pricing/icon-bill.svg" alt />
                  </div>
                  <p className="font-semibold text-gray-900 ml-3">
                    初期費用不要の月額定額制サービス
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
}
